import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import {SaveFile, UploadFile} from '@/vue-dlb/models'
import appUtil from '@/vue-dlb/utils/app-util'
import config from '@/vue-caas/config/config.js';

import {
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  callByDataSet,
  selectUserDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import { get } from "lodash";

const isDlbMybatis = config.isDlbMybatis;
const state = {
  movedata: [],
  foldList: [],
  fileList: [],
  fileListCheck: [],
  fileListSource: [],
  fileListFilter: null,
  savedFile: [],
  buildResult: [],
  exeResult: [],
  mapList: [],
  appliedList: [],
  mapFixed: [],
  chkinMapList: [],
  libList: []
};

const getters = {
};

const actions = {
  moveToMapBuilder : async ({commit}, movedata) => {
    commit('moveToMapBuilder', movedata);
  },
  clearMovedData: async({commit}, flag) => {
    commit('clearMoveData', flag);
  },
  queryLibraryList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("libList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryLibraryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_SITE_CONF_LIST_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryFolderList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("foldList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryFolderList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_BULD_LIST_USR_FOLD_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryFileList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("fileList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryFileList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_BULD_LIST_USR_FILES_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  addFolder: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("addFolder");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapBuilderManager";
      trSet.tranMethod = "addFolder";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_BULD_INS_USR_FOLD_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },

  //203665 2021/01/12 common issue 27 update folder name
  updateFolder: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("updateFolder");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapBuilderManager";
      trSet.tranMethod = "updateFolder";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_BULD_UPD_USR_FOLD_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  moveFile: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("moveFile");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapBuilderManager";
      trSet.tranMethod = "moveFile";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_BULD_MOVE_USR_FILES_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }   
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteWorkSpaceFiles: async ({ commit }, searchItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteWorkSpaceFiles");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "MapBuilderManager";
    trSet.tranMethod = "deleteWorkSpaceFiles";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  deleteWorkSpaceFolders: async ({ commit }, searchItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteWorkSpaceFolders");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "MapBuilderManager";
    trSet.tranMethod = "deleteWorkSpaceFolders";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  saveWorkSpaceMapFile: async ({ commit }, paramItems) => {
    let savefile = new SaveFile();
    savefile.data[0].DIV_KUBUN = 'WORK';
    savefile.data[0].BIZ_KUBUN = 'USER_MAPP';
    savefile.data[0].SITE_CODE = $cookies.get('comp-id');
    savefile.data[0].USER_KUBUN = $cookies.get('user-id');
    savefile.data[0].SUB_DIR = '';
    savefile.data[0].RENAME_YN = 'Y';
    savefile.data[0].FILE_ID = paramItems.data[0].FILE_ID;    // if FILE_ID exist, Save File to the file, if no, Save New File.
    savefile.data[0].FILE_NAME = paramItems.data[0].USR_FILE_NAME;
    let blob = new Blob([paramItems.data[0].file], { type: 'application/text' })
    savefile.data[0].file = blob;
    // Save File to Server
    const retSet = new ObjDataSet("SavedFile");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("saveWorkSpaceMapFile");
    condSet = appUtil.addDataHeader(savefile, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
    const formData = new FormData();
    formData.append('file', savefile.data[0].file, paramItems.data[0].USR_FILE_NAME);
    formData.append('trSet', JSON.stringify(trSet));
    await api.trFileSend("Filesave", formData).then(res => {
      commitRetDataSets(commit, res.data);
      let resdata = res.data;
      var trset = JSON.parse(JSON.stringify(resdata));
      var datasets = trset.DataSets;
      var datarows = datasets[0].DataRows;
      //////////////// 서버에 파일 저장 후 새로저장되었으면 부여받은 FILE ID, 기존 파일이면 기존 FILE_ID가 Return된다. //////////////
      paramItems.data[0].FILE_ID = datarows[0].FILE_NAME;  // Server file ID
      // paramItems.data[0].USR_FILE_SIZE = datarows[0].FILE_BYTE;  // Server file Size
    });

    // Update EDP_BULD_USR_FILES
    condSet = new ObjDataSet("condSet");
    trSet = new ObjTrSet("saveWorkSpaceMapFile");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "EDP_BULD_INS_USR_FILES_SP";
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapBuilderManager";
      trSet.tranMethod = "updateFile";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_BULD_INS_USR_FILES_SP";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  //203665 2021/01/12 common issue 27 update file name
  updateMapFileName: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("updateMapFileName");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapBuilderManager";
      trSet.tranMethod = "updateFile";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_BULD_INS_USR_FILES_SP";
      reqdata = execSPByDataSet(trSet); 
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  //203665 2021/01/12 common issue 27 update file name
  copyMapFileName: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("copyMapFileName");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapBuilderManager";
      trSet.tranMethod = "updateFile";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_BULD_INS_USR_FILES_SP";
      reqdata = execSPByDataSet(trSet);
    }

    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  mapBuild: async ({ commit }, paramItems) => {
    const retSet = new ObjDataSet("buildResult");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("mapBuild");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "MapBuilderManager";
    trSet.tranMethod = "build";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  mapExecute: async ({ commit }, paramItems) => {
    const retSet = new ObjDataSet("exeResult");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("mapExecute");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "MapBuilderManager";
    trSet.tranMethod = "execute";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  exeAlgetaScanner: async ({ commit }, paramItems) => {
    const retSet = new ObjDataSet("exeResult");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("algetaScannerExecute");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "MapBuilderManager";
    trSet.tranMethod = "executeAlgetaScanner";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryMapList: async ({ commit }, searchItems) => {
    const retSet1 = new ObjDataSet("mapList");
    const retSet2 = new ObjDataSet("appliedList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryMapList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet1);
    trSet.AddDataSet("O", "DS03", retSet2);
    trSet.tranID = "DS02:EDP_SRM_LIST_MAN_MAP_MST_FN|DS03:EDP_SRM_LIST_MAN_MAP_SRM_LST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryCheckinMapList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("chkinMapList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryCheckinMapList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_BULD_LIST_MAN_MAP_CHKIN_FN";
    trSet.suiParam = "USER_IDNO";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryFileListToCheck: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("fileListCheck");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryFileListToCheck");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_BULD_LIST_USR_FILES_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },

  saveCheckinMap: async ({ commit }, paramItems) => {
    // Map File Upload
    if(paramItems.data[0].file != null)
    {
      let uploadfile = new UploadFile();
      uploadfile.data[0].DIV_KUBUN = 'ASSET';
      uploadfile.data[0].BIZ_KUBUN = 'SAVE_MAP';
      uploadfile.data[0].SITE_CODE = $cookies.get('comp-id');
      uploadfile.data[0].USER_KUBUN = $cookies.get('user-id');
      uploadfile.data[0].SUB_DIR = paramItems.data[0].MAP_NAME;
      uploadfile.data[0].RENAME_YN = 'Y';
      uploadfile.data[0].FILE_NAME = paramItems.data[0].MAP_FILE_NAME;
      uploadfile.data[0].file = new Blob([paramItems.data[0].file], { type: 'application/text' });    // Change to blob data
      //uploadfile.data[0].file = paramItems.data[0].file;   map/checkInMap하고 요 부분만 다름. 나중에 fileID가져오는걸로 바뀌면 두개 메소드를 합쳐도 됨. 2020.08.06
      // Upload Mapper File
      const retSet = new ObjDataSet("UploadedFile");
      let condSet = new ObjDataSet("condSet");
      let trSet = new ObjTrSet("saveCheckinMap");
      condSet = appUtil.addDataHeader(uploadfile, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.AddDataSet("O", "DS02", retSet);
      trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
      const formData = new FormData();
      formData.append('file', uploadfile.data[0].file, uploadfile.data[0].FILE_NAME);
      formData.append('trSet', JSON.stringify(trSet));
      await api.trFileSend("Fileupload", formData).then(res => {
        let resdata = res.data;
        var trset = JSON.parse(JSON.stringify(resdata));
        var datasets = trset.DataSets;
        var datarows = datasets[0].DataRows;
        //////////////// 업로드 후 부여받은 FILE ID를 SET해주기 //////////////
        paramItems.data[0].MAP_FILE_ID = datarows[0].FILE_NAME;  // FlatFile Layout Excel Server file ID
        paramItems.data[0].MAP_FILE_SIZE = datarows[0].FILE_BYTE;  // FlatFile Layout Excel Server file Size
        // paramItems.data[0].MAPPER_NAME = paramItems.data[0].mappfile.name;  // FlatFile Layout File Name
      });
    }

    // Load From Server일 경우 파일을 Copy하기 위해 서버에 디렉토리 설정을 위해 UploadFile객체 같이 보내기
    /// Insert Data
    let copyfile = new UploadFile();
    copyfile.data[0].DIV_KUBUN = 'ASSET';
    copyfile.data[0].BIZ_KUBUN = 'SAVE_MAP';
    copyfile.data[0].SITE_CODE = $cookies.get('comp-id');
    copyfile.data[0].USER_KUBUN = $cookies.get('user-id');
    copyfile.data[0].SUB_DIR = paramItems.data[0].MAP_NAME;
    copyfile.data[0].RENAME_YN = 'Y';
    copyfile.data[0].FILE_NAME = paramItems.data[0].MAP_FILE_NAME;
    copyfile.data[0].file = '';
    let fileSet = new ObjDataSet("fileSet");
    fileSet = appUtil.addDataHeader(copyfile, fileSet);
    /////////////////////////
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("saveAddMap");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.AddDataSet("I", "DS02", fileSet);
    trSet3.tranID = "MapManManager";
    trSet3.tranMethod = "checkInMap";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },

  setFilterLoadFile: async ({ commit }, filter) => {
    commit('SET_FILE_LIST_FILTER', filter);
  },

};

const mutations = {
  moveToMapBuilder (state, datarows) {
    state.movedata = datarows;
  },
  clearMoveData (state, datarows){
    state.movedata = [];
    var tempobj = {
      flag: datarows,
      tab: null
    }
    state.movedata.push(tempobj);
    console.log(JSON.stringify(state.movedata))
  },
  chkinMapList (state, datarows) {
    state.chkinMapList = datarows;
  },
  foldList (state, datarows) {
    state.foldList = datarows;
  },
  libList (state, datarows) {
    state.libList = datarows;
  },
  fileList (state, datarows) {
    state.fileList = datarows;
    state.fileListSource = datarows;
  },
  fileListCheck (state, datarows) {
    state.fileListCheck = datarows;
  },
  SavedFile (state, datarows) {
    state.savedFile = datarows;
  },
  buildResult (state, datarows) {
    state.buildResult = datarows;
  },
  exeResult (state, datarows) {
    state.exeResult = datarows;
  },
  mapList (state, datarows) {
    state.mapList = datarows;
    state.mapFixed = datarows;
  },
  appliedList (state, datarows) {
    state.appliedList = datarows;
  },
  'SET_MAP_FILTER'(state, params) {
    let cus = params.cus;
    let locked = params.locked;
    let search = params.search;
    let checkScanner = params.CheckScanner;
    let arrFilter = state.mapFixed;
    if (cus != undefined && cus != '') {
      arrFilter = arrFilter.filter((item) => {
        return item.DATA_TYPE == cus;
      });
    }
    if (locked != undefined && locked != '') {
      if (checkScanner) {
        arrFilter = arrFilter.filter((item) => {
          return  item.MAP_SCAN_CHKIN_YN==locked;
        });
      } else if (!checkScanner) {
        arrFilter = arrFilter.filter((item) => {
          return  item.MAP_MAPP_CHKIN_YN==locked;
        });
      }
    }

    if (search != undefined && search != '') {
      arrFilter = arrFilter.filter((item) => {
        for (const prop in item) {
          if(!checkScanner){
              if (prop =="MAP_NAME" || prop == "MAP_MAPP_CHKIN_YN" || prop == "MAPPER_NAME" || prop == "MAP_UPD_DT" || prop == "MAPP_VER"){
                  if (typeof item[prop] == 'string') {
                    let propValue = item[prop].toLowerCase();
                    let queryValue = search.toLowerCase();
                    if (propValue.includes(queryValue)) {
                      return true;
                    }
                  } else if (typeof item[prop] == 'number') {
                    let propValue = item[prop].toString().toLowerCase();
                    let queryValue = search.toLowerCase();
                    if (propValue.includes(queryValue)) {
                      return true;
                    }
                  }
              }
          } else {
            if (prop =="MAP_NAME" || prop == "MAP_SCAN_CHKIN_YN" || prop == "SCANNER_NAME" || prop == "MAP_UPD_DT" || prop == "SCAN_VER"){
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = search.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = search.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          }
        }
      });
    }
    state.mapList = arrFilter;
  },
  'SET_FILE_LIST_FILTER' (state, filter) {
    let datarows = state.fileListSource;
    state.fileListFilter = filter;
    let filterBy = state.fileListFilter;
    let listResult = [];
    if (filterBy != null) {
      let filter = filterBy.filter;
      let str = filterBy.str;
      if (str.trim() == '') {
        listResult = datarows;
      }
      listResult = datarows.filter(item =>  {
        if(filter == 'all') {
          for (const prop in item) {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        } else {
          if (typeof item[filter] == 'string') {
            let propValue = item[filter].toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[filter] == 'number') {
            let propValue = item[filter].toString().toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }

        return false;
      });
    }
    state.fileList = listResult;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
